









import { Component, Vue, Prop } from 'vue-property-decorator';

type FormState = 'loading' | 'form';

@Component
export default class OrderRatingFormWidget extends Vue {
    @Prop({ required: true })
    private formId!: string;

    @Prop({ default: '6575304' })
    private portalId!: string;

    @Prop({ default: 'eu1' })
    private region!: string;

    private state: FormState = 'loading';

    mounted() {
        this.state = 'form';
        this.$nextTick(() => this.mountHubSpotForm());
    }

    beforeDestroy() {
        // No-op — kept for future use
    }

    private mountHubSpotForm(): void {
        const container = document.getElementById('hs-rating-form-target');
        if (!container) return;

        // Use HubSpot's new hs-form-frame embed (same as original pages used).
        // Data attributes are HubSpot's documented way to pre-fill fields in this embed.
        const hsDiv = document.createElement('div');
        hsDiv.className = 'hs-form-frame';
        hsDiv.setAttribute('data-region', this.region);
        hsDiv.setAttribute('data-form-id', this.formId);
        hsDiv.setAttribute('data-portal-id', this.portalId);

        container.appendChild(hsDiv);

        // Load the portal-specific embed script (same script original pages loaded)
        const scriptSrc = `//js-eu1.hsforms.net/forms/embed/${this.portalId}.js`;
        if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.defer = true;
            document.body.appendChild(script);
        }
    }
}
